export default __webpack_public_path__ + "static/media/freeform-logo-3.a0a5f8be.png";